import {makeLxTranslations} from "@lxo-blocks/react";

const METHODS_VIEW_TRANSLATION = makeLxTranslations({
    namespace: "methodsViewTranslations",
    translations: {
        HEADLINE: "<bold>Wählen Sie aus, wie Sie sich anmelden möchten:</bold>",
        METHOD_MFAPUSH: "Tippen Sie auf Ihrem Smartphone auf “Ja”",
        METHOD_TOTP: "Per Code aus einer Authenticator App",
        METHOD_RECOVERYCODE: "Ersatzcode einlösen und Ameldung in zwei Schritten deaktivieren",
        METHOD_HELP: "Hilfe erhalten",
        METHOD_CHANGE_BTN: "andere Methode wählen",
        ERROR_HEADLINE: "Es ist ein Fehler aufgetreten",
        ERROR_TEXT: "Bitte versuchen Sie es erneut."
    }
});

export {METHODS_VIEW_TRANSLATION};
